import { Link, type LinkProps } from 'react-router-dom';
import styles from './Button.module.css';

/** Navigation with the same shape, colours and spacing as the shared action button. */
export function ButtonLink({ variant = 'primary', className, ...props }: LinkProps & {
  variant?: 'primary' | 'secondary' | 'ghost';
}) {
  return <Link {...props} className={[styles.button, styles[variant], className].filter(Boolean).join(' ')} />;
}
